const calculatePercentage = (amount: number, part: number): number => {
  if (amount === 0) {
    return 0;
  }

  return (part / amount) * 100;
};

export default calculatePercentage;
